module.exports = __webpack_public_path__ + "img/pin-station.70cd539f.svg";